import { gql } from '@apollo/client';

import { SpRegistration } from '../ProviderRegister.helpers';

export type ProviderRegisterL2Response = {
  l2BySlug: {
    id: string;
    slug: string;
    name: string;
    requestCountSinceLastWeek?: number;
    spRegistration: SpRegistration;
    categories: {
      id: string;
      name: string;
      slug: string;
    }[];
  };
};

export const providerRegisterL2Query = gql`
  query ProviderRegisterL2($slug: String!) {
    l2BySlug(slug: $slug) {
      id
      slug
      name
      requestCountSinceLastWeek
      spRegistration {
        metaTitle
        metaDescription
        coverUrl
        mobileCoverUrl
      }
      categories {
        id
        name
        slug
      }
    }
  }
`;
